import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, keys, type Channel, type Uuid } from "@shared/api";
import { greeted, useGreeting } from "../model/greeting";
import { WelcomeModal } from "./WelcomeModal";

/**
 * Экран приветствия новичку — когда открыт сервер, на который только что
 * вступили. Выключен или пуст — пометка снимается молча.
 */
export function WelcomeGate({
  serverId,
  serverName,
  channels,
  onOpenChannel,
}: {
  serverId: Uuid | null;
  serverName?: string;
  channels?: Channel[];
  onOpenChannel: (channelId: Uuid) => void;
}) {
  const pending = useGreeting((state) => state.pending);
  const due = !!serverId && pending === serverId;
  const { data, isError } = useQuery({
    queryKey: keys.welcome(serverId ?? ""),
    queryFn: () => api.welcome.get(serverId!),
    enabled: due,
  });
  const empty = !!data && (!data.enabled || (!data.description && !data.channels?.length));

  useEffect(() => {
    if (due && (isError || empty)) greeted();
  }, [due, isError, empty]);

  if (!due || !data || empty || !channels || !serverName) return null;

  return (
    <WelcomeModal
      serverName={serverName}
      screen={data}
      channels={channels}
      onOpenChannel={onOpenChannel}
      onClose={greeted}
    />
  );
}
